import { create } from 'zustand';

interface AuthState {
  email: string | null;
  setEmail: (email: string) => void;
  clearEmail: () => void;
}

export const useAuthForgotPasswordStore = create<AuthState>((set) => ({
  email: null,
  setEmail: (email) => set({ email }),
  clearEmail: () => set({ email: null }),
}));
